import {
  Calculate,
  CalendarMonth,
  CheckCircle,
  ErrorRounded,
  Input,
  Timeline,
  Transform,
  WatchLater,
} from "@mui/icons-material"
import { DefaultComponentProps, OverridableTypeMap } from "@mui/material/OverridableComponent"
import { RunStatusDto } from "@store/services/runService"

type RunStatusIconProps = DefaultComponentProps<OverridableTypeMap> & {
  status: RunStatusDto
}

const iconColor = {
  error: "#ef0000",
  info: "#e19d21",
  success: "#2a862a",
}

const RunStatusIcon = ({ status, ...props }: RunStatusIconProps) => {
  const commonStyles = {
    fontSize: 20,
    ...props?.sx,
  }

  switch (status) {
    case RunStatusDto.SCHEDULE:
      return <CalendarMonth sx={{ color: iconColor.info, ...commonStyles }} />
    case RunStatusDto.CONVERT:
      return <Timeline sx={{ color: iconColor.info, ...commonStyles }} />
    case RunStatusDto.SAMPLE:
      return <Calculate sx={{ color: iconColor.info, ...commonStyles }} />
    case RunStatusDto.TRANSFORM:
      return <Transform sx={{ color: iconColor.info, ...commonStyles }} />
    case RunStatusDto.INSERT:
      return <Input sx={{ color: iconColor.info, ...commonStyles }} />

    case RunStatusDto.DONE:
      return <CheckCircle sx={{ color: iconColor.success, ...commonStyles }} />
    case RunStatusDto.TIMEOUT:
      return <WatchLater sx={{ color: iconColor.error, ...commonStyles }} />
    case RunStatusDto.ERROR:
      return <ErrorRounded sx={{ color: iconColor.error, ...commonStyles }} />

    default:
      return <></>
  }
}

export default RunStatusIcon
